import { render, staticRenderFns } from "./SelectByAppForm.vue?vue&type=template&id=5172b20e&scoped=true"
import script from "./SelectByAppForm.vue?vue&type=script&lang=ts"
export * from "./SelectByAppForm.vue?vue&type=script&lang=ts"
import style0 from "./SelectByAppForm.vue?vue&type=style&index=0&id=5172b20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172b20e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/search.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FSelectByAppForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports